import React from 'react';
import { motion } from 'framer-motion';

interface Props {
  sectionVariants: any;
  itemVariants: any;
}

export const PersonalTouchSection: React.FC<Props> = ({ sectionVariants, itemVariants }) => {
  return (
    <motion.section
      className="py-28 md:py-36 px-6 md:px-12 bg-white border-t border-ink-line"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.15 }}
      variants={sectionVariants}
    >
      <div className="max-w-7xl mx-auto">
        <div className="max-w-2xl">
          <motion.p
            className="text-xs uppercase tracking-eyebrow text-ink-muted mb-8"
            variants={itemVariants}
          >
            How We Work
          </motion.p>
          <motion.h2
            className="font-display text-4xl md:text-5xl leading-tight tracking-tight mb-8"
            variants={itemVariants}
          >
            We're the ones <span className="italic">on the hook.</span>
          </motion.h2>
          <motion.div className="space-y-6" variants={itemVariants}>
            <p className="text-lg text-ink-soft leading-relaxed">
              We don't advise from the outside. We own what we build, run it, and live with the
              consequences of every decision — the formulation, the bid, the release.
            </p>
            <p className="text-lg text-ink leading-relaxed">
              That's the only way we know whether an idea actually holds up.
            </p>
          </motion.div>
        </div>
      </div>
    </motion.section>
  );
};
